/** Zendesk + Jira issue collector — legacy GT only, not PARA `/progress`. */

const ZENDESK_SNIPPET_URL =
	'https://static.zdassets.com/ekr/snippet.js?key=c0316d42-e688-4829-8c7c-177a440c62dc';
const JIRA_COLLECTOR_URL =
	'https://thelearningbar.atlassian.net/s/d41d8cd98f00b204e9800998ecf8427e-T/azc3hx/b/7/c95134bc67d3a521bb3f4331beb9b804/_/download/batch/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector.js?locale=en-US&collectorId=357bd178';

declare global {
	interface Window {
		zESettings?: { webWidget: { hideWhenOffline: boolean } };
		zE?: (...args: unknown[]) => void;
	}
}

export function isParaProgressPath(pathOrUrl: string): boolean {
	const path = (pathOrUrl.split('?')[0].split('#')[0] || '/').replace(/\/+$/, '') || '/';
	return path === '/progress' || path.startsWith('/progress/');
}

let widgetsInjected = false;

function appendScript(id: string | null, src: string): void {
	if (id && document.getElementById(id)) {
		return;
	}
	const script = document.createElement('script');
	script.type = 'text/javascript';
	if (id) {
		script.id = id;
	}
	script.src = src;
	document.body.appendChild(script);
}

function injectLegacySupportWidgets(): void {
	if (widgetsInjected) {
		return;
	}
	widgetsInjected = true;
	window.zESettings = {
		webWidget: {
			hideWhenOffline: true,
		},
	};
	appendScript('ze-snippet', ZENDESK_SNIPPET_URL);
	appendScript(null, JIRA_COLLECTOR_URL);
}

function setZendeskVisible(visible: boolean): void {
	if (typeof window.zE !== 'function') {
		return;
	}
	try {
		window.zE('webWidget', visible ? 'show' : 'hide');
	} catch {
		/* snippet not ready */
	}
}

function setJiraCollectorVisible(visible: boolean): void {
	const display = visible ? '' : 'none';
	document
		.querySelectorAll<HTMLElement>('.atlwdg-trigger, #atlwdg-blanket, .atlwdg-popup')
		.forEach((el) => {
			el.style.display = display;
		});
}

/** Load widgets on legacy routes; hide (or skip load) on PARA `/progress`. */
export function syncLegacySupportWidgets(pathOrUrl: string): void {
	if (isParaProgressPath(pathOrUrl)) {
		setZendeskVisible(false);
		setJiraCollectorVisible(false);
		return;
	}
	injectLegacySupportWidgets();
	setZendeskVisible(true);
	setJiraCollectorVisible(true);
}
